export default __webpack_public_path__ + "assets/4fd4081ec5d8f716c615e4108e2df4ca.gif";